import { InjectionToken } from '@angular/core';
import type { PmWorkspaceComponent } from '../../../layout/pm-workspace/pm-workspace.component';

/**
 * What the profile menu still reads from the workspace: its open flag (also driven by the top bar avatar, Escape and outside-click handling) and the shared Settings link.
 * The workspace provides itself under this token. Shrinks as the shared stores are split out.
 */
export type PmShellProfileMenuHost = Pick<
  PmWorkspaceComponent,
  | 'isProfileMenuOpen'
  | 'profile'
  | 'stopProp'
>;

export const PM_SHELL_PROFILE_MENU_HOST = new InjectionToken<PmShellProfileMenuHost>('PmShellProfileMenuHost');
